import { Link } from "react-router-dom";
import "../styles/BuildClub.scss";

const PodsyMark = () => (
    <svg width="52" height="32" viewBox="0 0 160 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="4" y="4" width="152" height="92" rx="14" fill="#f7f7f5" />
        <circle cx="58" cy="50" r="17" stroke="#0a0f14" strokeWidth="7" />
        <circle cx="108" cy="50" r="12" fill="#e67700" />
        <circle cx="108" cy="50" r="2.2" fill="#0a0f14" />
        <circle cx="58" cy="50" r="3.4" fill="#e67700" />
    </svg>
);

const Build = () => (
    <div className="lead-page mkt-page">
        <div className="mkt-ambient-glow" aria-hidden="true" />

        <header className="mkt-header">
            <Link to="/" className="mkt-header__brand">
                <PodsyMark />
                Podsy
            </Link>
        </header>

        <main className="mkt-main mkt-main--build">
            <p className="mkt-eyebrow mkt-eyebrow--center">Build my Club</p>
            <h1 className="mkt-h1">Let's build your Podcast Club</h1>
            <p className="mkt-lede">
                Sign up below and you'll land straight in the builder. About fifteen
                minutes, start to finish.
            </p>

            <ol className="mkt-steps">
                <li>
                    <span className="mkt-steps__num">1</span>
                    <p>Sign up with your email.</p>
                </li>
                <li>
                    <span className="mkt-steps__num">2</span>
                    <p>Add your podcast's RSS feed.</p>
                </li>
                <li>
                    <span className="mkt-steps__num">3</span>
                    <p>Podsy drafts your Club automatically from your existing episodes. Review it and ship as-is or refine it.</p>
                </li>
            </ol>

            <div className="mkt-card mkt-signup-card">
                <Link to="/signup" className="mkt-btn mkt-btn--block">
                    Sign up and start building
                </Link>
                <p className="mkt-signup-card__footnote">
                    Don't know your RSS feed?{" "}
                    <a href="https://rss.com/tools/find-my-feed/" target="_blank" rel="noopener noreferrer">
                        Find it here
                    </a>.
                </p>
            </div>
        </main>
    </div>
);

export default Build;
